import React, {useState, useCallback, useEffect} from 'react';
import {useSelector} from "react-redux";
import {clone, set, throttle, get} from 'lodash';
import classNames from 'classnames';

import MindsetsJsSDK from "mindsets-js-sdk";
import analytic from 'utils/Analytic';

const FEEDBACK_QUESTIONS = [
    'How do you feel about this new page?',
    `How excited are you to 'level up' your Mindsets Skills?`,
    'Is this new page helpful for your learning?'
];

export default function ({first_skill_data}) {
    const [popup, setPopup] = useState(false);
    const [feedback, setFeedback] = useState([null, null, null]);
    const me = useSelector(state => state.me);

    useEffect(() => {
        if (me && !me.is_dashboard_super_admin) {
            const skills_passport_feedback = get(me, 'general_data.skills_passport_feedback', false);
            setTimeout(() => {
                if (!skills_passport_feedback && !popup) {
                    setPopup(true);
                }
            }, 10000);
        }
    }, [me]);

    const onClickPopup = () => {
        setPopup(!popup);
    }

    const onClickFace = (question, face) => () => {
        const new_feedback = clone(feedback);
        set(new_feedback, [question], face);
        setFeedback(new_feedback);

        analytic.log(
            'feedbackSelect',
            'skills-passport',
            FEEDBACK_QUESTIONS[question],
            face
        );
    }

    const onSubmit = () => {
        setPopup(false);

        const question_and_feedback = FEEDBACK_QUESTIONS.map((question, key) => {
            analytic.log(
                'feedbackSubmit',
                'skills-passport',
                question,
                feedback[key] ?? 'empty'
            );
            return question + ' User feedback: ' + (feedback[key] ?? 'empty') + '.';
        });
        const text = first_skill_data.school_name + ', ' + first_skill_data.state + ', ' + first_skill_data.country + '\n'
            + `Student submited feedback:\n`
            + question_and_feedback.join('\n');
        return sendToSlack(text).then(() => {
            return MindsetsJsSDK().API.put('me', {
                general_data: {skills_passport_feedback: 1}
            })
        }).catch((error) => {
            console.error(error);
        });
    }
    const onSubmitThrottle = throttle(onSubmit, 5000, {'trailing': false});

    const sendToSlack = (text) => {
        const slack_web_hook = 'https://hooks.slack.com/services/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';
        const body = {
            text
        };
        return fetch(slack_web_hook, {
            method: 'POST',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: JSON.stringify(body)
        }).then((response) => {
            if (response.ok) {
            }
        });
    }

    const renderPopup = () => {
        if (!popup) {
            return null;
        }

        const renderQuestions = () => {
            return FEEDBACK_QUESTIONS.map((question, key) => {
                return (
                    <div className="ssp-feedback-question" key={key}>
                        <div>
                            {question}
                        </div>
                        <Faces
                            question={key}
                            feedback={feedback[key]}
                            onClickFace={onClickFace}
                        />
                    </div>
                );
            });
        }

        return (
            <div className="ssp-feedback-popup">
                <div className="ssp-feedback-popup-title flex-row flex-vh-center flex-gap-5">
                    <i className="far fa-comment-alt"></i>
                    <span>{`Feedback`}</span>
                </div>

                {renderQuestions()}

                <div className="ssp-feedback-submit" onClick={onSubmitThrottle}>
                    {`OK`}
                </div>
            </div>
        );
    }

    return (
        <div className="ssp-feedback">
            <div className="ssp-feedback-trigger flex-row flex-vh-center flex-gap-5" onClick={onClickPopup}>
                <i className="far fa-comment-alt" />
                <span>{`Feedback`}</span>
            </div>

            <div className="ssp-feedback-popup-outter">
                {renderPopup()}
            </div>
        </div>
    );
}

function Faces ({question, feedback, onClickFace}) {
    const face_classnames_a = classNames(
        'far fa-meh',
        {
            'ssp-feedback-face-active': feedback === 1
        }
    );
    const face_classnames_b = classNames(
        'far fa-smile',
        {
            'ssp-feedback-face-active': feedback === 5
        }
    );
    const face_classnames_c = classNames(
        'far fa-grin-hearts',
        {
            'ssp-feedback-face-active': feedback === 10
        }
    );
    return (
        <div className="ssp-feedback-faces flex-row flex-vh-center flex-between">
            <i className={face_classnames_a} onClick={onClickFace(question, 1)} />
            <i className={face_classnames_b} onClick={onClickFace(question, 5)} />
            <i className={face_classnames_c} onClick={onClickFace(question, 10)} />
        </div>
    );
}